const products = {
    "Startup Registration": "prod_OYIlIRIPkmzrfl",
    "Content Access": "prod_OYEQhWZdRWMgrt",
    "VC Registration": "prod_QRjamrqHorBy67",
    "Angel Investor Registration": "prod_RPjru78DnSWxJ1"
  }
export default products;
